import { useTranslation } from 'react-i18next';

import { useAuthUser } from '@/auth/useAuthUser';
import { getEnabledModules } from '@/modules/registry';

export default function DashboardPage() {
  const { t } = useTranslation();
  const user = useAuthUser();
  const modules = user ? getEnabledModules(user.modules, user.roles) : [];

  return (
    <div>
      <h1 className="text-2xl font-semibold text-slate-900">{t('nav.dashboard')}</h1>
      <p className="mt-1 text-sm text-slate-600">{t('app.tagline')}</p>

      <section className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {modules.map((m) => (
          <a
            key={m.id}
            href={m.path}
            className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm transition hover:border-brand-500 hover:shadow"
          >
            <div className="text-3xl">{m.icon}</div>
            <div className="mt-2 text-base font-semibold text-slate-900">{t(m.i18nKey)}</div>
          </a>
        ))}
        {modules.length === 0 && (
          <p className="text-sm text-slate-500">{t('auth.moduleDisabled')}</p>
        )}
      </section>

      {user && (
        <section className="mt-8 rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
          <h2 className="text-sm font-semibold text-slate-900">Session</h2>
          <dl className="mt-2 grid grid-cols-1 gap-x-4 gap-y-1 text-xs text-slate-600 sm:grid-cols-2">
            <dt className="font-medium">tenant_id</dt>
            <dd className="font-mono">{user.tenantId ?? '—'}</dd>
            <dt className="font-medium">roles</dt>
            <dd>{user.roles.join(', ') || '—'}</dd>
            <dt className="font-medium">modules</dt>
            <dd>{user.modules.join(', ') || '—'}</dd>
          </dl>
        </section>
      )}
    </div>
  );
}
